import React, { useEffect } from 'react';
import UserStatusesPage from './user-statuses/UserStatusesPage';
import './users/users.css';
import './users/brand.css';
import './user-statuses/statuses.css';

export default function UserStatusManagement() {
  useEffect(() => {
    document.body.classList.add('users-brand');
    return () => document.body.classList.remove('users-brand');
  }, []);
  return <UserStatusesPage />;
}
